import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type { BaseProfitItemsVars, UseBulkEditProfitItemsData } from './types';

export type UseBulkCreateProfitItemsData = UseBulkEditProfitItemsData;

export type UseBulkCreateProfitItemsVars = BaseProfitItemsVars & {
  deleteExistingProfitItems: boolean;
};

export const useBulkCreateProfitItems: MutationFunction<
  UseBulkCreateProfitItemsData,
  UseBulkCreateProfitItemsVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/bulk_create_profit_items`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
